import { __rest } from '../../_virtual/_tslib.js';
import { IconLinkWrapper } from '@lsg/shared';
import { createElement } from 'react';
import { IconLinkGroup } from '../IconLinkGroup/IconLinkGroup.js';

/** @deprecated (date: 10.11.2021) */
var Looks;
(function (Looks) {
  Looks["LEFT"] = "left";
  Looks["RIGHT"] = "right";
  Looks["NO_ICON"] = "no-icon";
  Looks["NO_TEXT"] = "no-text";
  Looks["NO_TEXT_NO_HOVER"] = "no-text";
})(Looks || (Looks = {}));
/** @deprecated (date: 10.11.2021) */
var Colors;
(function (Colors) {
  Colors["DEFAULT"] = "primary";
  Colors["SECONDARY"] = "secondary";
})(Colors || (Colors = {}));
var IconLink = function IconLink(_a) {
  var _a$color = _a.color,
    color = _a$color === void 0 ? "primary" : _a$color,
    _a$iconVariant = _a.iconVariant,
    iconVariant = _a$iconVariant === void 0 ? "outline" : _a$iconVariant,
    children = _a.children,
    refCallback = _a.refCallback,
    props = __rest(_a, ["color", "iconVariant", "children", "refCallback"]);
  return /*#__PURE__*/createElement(IconLinkWrapper, Object.assign({}, props, {
    secondary: color === Colors.SECONDARY,
    iconVariant: iconVariant,
    actionRef: refCallback
  }), /*#__PURE__*/createElement("div", null, children));
};
IconLink.Looks = Looks;
IconLink.Colors = Colors;
IconLink.Group = IconLinkGroup;
IconLink.displayName = "IconLink";

export { IconLink, Looks };
